import React from "react";
import Card from "@/components/common/card/Card";
import DataSelect from "@/components/common/select/DataSelect";
import Tabs from "@/components/common/tab/Tab";
import styles from "./AnswersTable.module.css";
import type { answersTableProps } from "./types.props";

export const AnswerFilters: React.FC<{
    sessions: any[];
    availableTests: any[];
    selectedSessionId: number | null;
    selectedTestId: number | null;
    onSessionChange: (id: number) => void;
    onTestChange: (id: number) => void;
}> = ({
    sessions,
    availableTests,
    selectedSessionId,
    selectedTestId,
    onSessionChange,
    onTestChange,
}) => (
        <Card>
            <Tabs
                items={sessions.map((s) => ({ key: String(s.id), label: s.name }))}
                activeKey={String(selectedSessionId ?? "")}
                onTabChange={(key) => onSessionChange(Number(key))}
            />
            <DataSelect
                label="Seleccione una prueba para ver las respuestas:"
                name="test-selector"
                value={selectedTestId || ""}
                onChange={(e) => onTestChange(Number(e.target.value))}
                options={availableTests.map((test) => ({
                    value: test.id,
                    label: test.test_type.name,
                }))}
                placeholder="Seleccione una prueba"
            />
        </Card>
    );

const ANSWER_OPTIONS = [
    { value: "", label: "N/A" },
    { value: "A", label: "A" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
    { value: "D", label: "D" },
    { value: "E", label: "E" },
    { value: "F", label: "F" },
    { value: "G", label: "G" },
];

const AnswersTable: React.FC<answersTableProps> = ({
    questions,
    answers,
    disabled = false,
    onAnswerChange,
}) => {
    const sortedQuestions = React.useMemo(
        () =>
            [...questions].sort(
                (a, b) => a.session_question_number - b.session_question_number,
            ),
        [questions],
    );
    return (
        <Card>
            <div className={styles["table-responsive"]}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th className={styles["header-question-number"]}># Pregunta</th>
                            <th>Respuesta del estudiante</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedQuestions.map((q) => (
                            <tr key={q.id}>
                                <td className={styles["cell-question-number"]}>
                                    {q.session_question_number ?? "—"}
                                </td>
                                <td>
                                    <DataSelect
                                        id={`q-${q.id}`}
                                        name={`q-${q.id}`}
                                        value={answers[String(q.id)] || ""}
                                        onChange={(e) => onAnswerChange(q.id, e.target.value)}
                                        options={ANSWER_OPTIONS}
                                        disabled={disabled}
                                        label=""
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Card>
    );
};

export default AnswersTable;
